export default __webpack_public_path__ + "static/media/problema-06.382a53de.webp";